import { Fragment, useContext } from 'react';
import Compare from '../Compare';
import Stack from '../../../shared/layouts/Stack';
import CategoryHeader from '../CategoryHeader';
import { CompareContext } from '../ComparePage';
import { findTranslation } from '../../../../utils/helpers';
import CompareLoanpartSection from "./CompareLoanpartSection";
import {useTranslation} from "react-i18next";

const SECTION = 'mortgage_general';

const CompareMortgageSection = () => {
  const {
    showOnlyDiff,
    hasDiff,
    shouldShow,
    ownMortgageData,
    otherMortgageData,
    handleMortgageDataChange,
    meta: { mortgageProviders = [] },
    mortgageFields,
    loanpartFields,
    hasSectionCopiedFields,
  } = useContext(CompareContext);

  const { t } = useTranslation();

  const handleMortgageGeneralDataChange =
    (index, section, fieldName) => (e) => {
      handleMortgageDataChange(e, index, section, fieldName);
    };

  const renderMortgages =
    ownMortgageData?.length > otherMortgageData?.length
      ? ownMortgageData
      : otherMortgageData;

  return renderMortgages?.map((mortgage, index) => {
    const ownMortgage = ownMortgageData?.[index] || {};
    const otherMortgage = otherMortgageData?.[index] || {};
    const MORTGAGE_SECTION = `${SECTION}_${index}`;
    const mortgageHeader = t(`Hypotheek {{index}}`, {index: renderMortgages.length > 1 ? index + 1 : ''});

    if (
      showOnlyDiff &&
      !hasSectionCopiedFields(MORTGAGE_SECTION) &&
      !hasDiff(mortgageFields, ownMortgage, otherMortgage) &&
      !ownMortgage?.loanparts?.some((lp, index) =>
        hasDiff(loanpartFields, lp, otherMortgage?.loanparts?.[index])
      )
    )
      return null;

    return (
      <Fragment key={`mortgage_${index}`}>
        <Stack space="l">
          <CategoryHeader>
            <span>{mortgageHeader}</span>
            <span>{mortgageHeader}</span>
          </CategoryHeader>
          <Stack space="m">
            {shouldShow(
              'provider',
              ownMortgage,
              otherMortgage,
              MORTGAGE_SECTION
            ) && (
              <Compare
                label={t("Hypotheekverstrekker")}
                name="provider"
                section={MORTGAGE_SECTION}
                leftValue={ownMortgage?.provider}
                rightValue={otherMortgage?.provider}
                valueTransformer={(value) =>
                  findTranslation(value, mortgageProviders)
                }
                onUpdate={handleMortgageGeneralDataChange(
                  index,
                  MORTGAGE_SECTION,
                  'provider'
                )}
              />
            )}
            {shouldShow(
              'label',
              ownMortgage,
              otherMortgage,
              MORTGAGE_SECTION
            ) && (
              <Compare
                label={t("Label")}
                name="label"
                section={MORTGAGE_SECTION}
                leftValue={ownMortgage?.label}
                rightValue={otherMortgage?.label}
                valueTransformer={(value) => {
                  const provider = mortgageProviders.find((provider) =>
                    provider.labels.find((label) => label.value === value)
                  );
                  return findTranslation(value, provider?.labels);
                }}
                onUpdate={handleMortgageGeneralDataChange(
                  index,
                  MORTGAGE_SECTION,
                  'label'
                )}
              />
            )}
            {shouldShow(
              'mortgagenumber',
              ownMortgage,
              otherMortgage,
              MORTGAGE_SECTION
            ) && (
              <Compare
                label={t("Hypotheeknummer")}
                name="mortgagenumber"
                section={MORTGAGE_SECTION}
                leftValue={ownMortgage?.mortgagenumber}
                rightValue={otherMortgage?.mortgagenumber}
                onUpdate={handleMortgageGeneralDataChange(
                  index,
                  MORTGAGE_SECTION,
                  'mortgagenumber'
                )}
              />
            )}
            {shouldShow(
              'originalAmount',
              ownMortgage,
              otherMortgage,
              MORTGAGE_SECTION
            ) && (
              <Compare
                label={t("Oorspronkelijke hoofdsom")}
                name="originalAmount"
                section={MORTGAGE_SECTION}
                leftValue={ownMortgage?.originalAmount}
                rightValue={otherMortgage?.originalAmount}
                onUpdate={handleMortgageGeneralDataChange(
                  index,
                  MORTGAGE_SECTION,
                  'originalAmount'
                )}
                isCurrency
              />
            )}
          </Stack>
        </Stack>
        <CompareLoanpartSection mortgageIndex={index} />
      </Fragment>
    );
  }) || null;
};

export default CompareMortgageSection;
